import React from "react";
import { Routes, Route } from "react-router";
import { ToastContainer } from "react-toastify";

import * as m from "@/shared/styles/main.module.scss";
import Header from "@/shared/components/Header";

import HomePage from "@/features/home/pages/HomePage";
import StartPage from "@/features/poll/pages/StartPage";
import Poll from "@/features/poll/pages/PollPage";
import Success from "@/features/poll/pages/SuccessPage";

const App: React.FC = () => {
  return (
    <>
      <div className={m.container}>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/slms/:id"
            element={<StartPage surveyPlatform="Lms" />}
          />
          <Route
            path="/slms/preview/:id"
            element={<StartPage surveyPlatform="Lms" preview />}
          />
          <Route path="/cs/:id" element={<StartPage surveyPlatform="Vb" />} />
          <Route path="/hns/:id" element={<StartPage surveyPlatform="Vb" />} />
          <Route path="/poll/:id" element={<Poll />} />
          <Route path="/success/:id" element={<Success />} />
          <Route
            path="/customer_score/preview_start/:id"
            element={<StartPage preview={true} surveyPlatform="Vb" />}
          />
          <Route
            path="/hub_and_spoke/preview_start/:id"
            element={<StartPage preview={true} surveyPlatform="Vb" />}
          />
          <Route path="/preview_poll/:id" element={<Poll preview={true} />} />
          <Route path="/preview_success/:id" element={<Success />} />
        </Routes>
      </div>
      <ToastContainer />
    </>
  );
};

export default App;
